import { Button } from "@unfiddle/ui/components/button"
import {
   Drawer,
   DrawerFooter,
   DrawerPopup,
   DrawerTitle,
} from "@unfiddle/ui/components/drawer"
import { number } from "@unfiddle/ui/utils"
import { useAtom } from "jotai"
import type * as React from "react"
import { useAuth } from "@/auth/hooks"
import { OrderForm } from "@/order/components/order-form"
import { useCreateOrder } from "@/order/create/use-create-order"
import { createOrderOpenAtom } from "@/order/store"

export function CreateOrder({ children }: { children?: React.ReactNode }) {
   const auth = useAuth()
   const [open, setOpen] = useAtom(createOrderOpenAtom)
   const mutation = useCreateOrder({
      onMutate: () => setOpen(false),
      onError: () => setOpen(true),
   })

   return (
      <Drawer
         open={open}
         onOpenChange={setOpen}
      >
         {children}
         <DrawerPopup data-testid="create-order-popup">
            <DrawerTitle>Нове замовлення</DrawerTitle>
            <OrderForm
               onSubmit={(form) =>
                  mutation.mutate({
                     ...form,
                     workspaceId: auth.workspace.id,
                     sellingPrice: number(form.sellingPrice),
                  })
               }
            >
               <DrawerFooter>
                  <Button type="submit">Додати</Button>
               </DrawerFooter>
            </OrderForm>
         </DrawerPopup>
      </Drawer>
   )
}
